module.exports = __webpack_public_path__ + "img/labs.f99b683b.svg";